import type { User } from '@supabase/supabase-js'
import { getVoornaamAchternaam } from './klantProfielHelpers'

/** Initiële `app_profiles.role` uit auth metadata. */
export function getInitialProfileRoleFromMetadata (
  meta: Record<string, unknown> | undefined
): 'user' | 'salon' {
  return meta?.account_kind === 'salon_owner' ? 'salon' : 'user'
}

/** Weergavenaam uit voornaam/achternaam of full_name in user_metadata. */
export function getDisplayNameFromUserMetadata (user: User): string | null {
  const { voornaam, achternaam } = getVoornaamAchternaam(user, null)
  const combined = `${voornaam} ${achternaam}`.trim()
  return combined || null
}

/** Telefoon uit user_metadata (registratie / uitnodiging). */
export function getPhoneFromUserMetadata (
  meta: Record<string, unknown> | undefined
): string | null {
  const tele = typeof meta?.telefoon === 'string' ? meta.telefoon.trim() : ''
  const phone = typeof meta?.phone === 'string' ? meta.phone.trim() : ''
  const chosen = tele || phone
  return chosen || null
}
